import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toggleAwardsModal } from 'project/ducks/awards';
import { getCurrentWrapup } from 'project/ducks/wrapup';
import IncreaseAwardButton from 'project/components/wrapup/increase_award_button';

const mapStateToProps = (state, { params }) => {
  const wrapup = getCurrentWrapup(state, params.awardId);
  const isClient = state.user.profile_data.id === wrapup.client.id;

  return {
    /* don't show for offers or awards that were paid */
    show: isClient && wrapup.award.type === "award" && wrapup.stepIdx < wrapup.steps.length - 1
  };
}

export default withRouter(connect(mapStateToProps, {
  toggleAwardsModal
})(IncreaseAwardButton));



// WEBPACK FOOTER //
// ./project/containers/wrapup/increase_award_button.js